import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[onlyNumbers]',
  standalone: true
})
export class OnlyNumbersDirective {

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const input = event.clipboardData?.getData('text') || '';
    if (!/^\d+$/.test(input)) {
      event.preventDefault();
    }
  }
}

@Directive({
  selector: '[onlyAlphabet]'
})
export class OnlyAlphabetDirective {
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    if (!/^[a-zA-Z]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const input = event.clipboardData?.getData('text') || '';
    if (!/^[a-zA-Z]+$/.test(input)) {
      event.preventDefault();
    }
  }
}

@Directive({
  selector: '[onlyAlphabetWithSpace]'
})
export class OnlyAlphabetWithSpaceDirective {

  // Allow any Unicode letter (accents, UTF characters, etc.), space, and special characters (no digits)
  private regex = /^[\p{L} !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/u;

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    if (!this.regex.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const input = event.clipboardData?.getData('text') || '';
    if (!this.regex.test(input)) {
      event.preventDefault();
    }
  }
}

@Directive({
  selector: '[onlyMobileNumber]'
})
export class OnlyMobileNumberDirective {

  private regex: RegExp = /^[0-9+ ]$/;

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const char = event.key;

    // Allow control keys (backspace, tab, arrows)
    if (event.ctrlKey || event.metaKey || char.length > 1) {
      return;
    }

    if (!this.regex.test(char)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const input = event.clipboardData?.getData('text') || '';

    // Full string validation
    if (!/^\+?[0-9 ]+$/.test(input)) {
      event.preventDefault();
    }
  }
}